module.exports = __webpack_public_path__ + "static/media/heroku.e9a31cff.png";